// SafetyHero.jsx
import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import {
    MdArrowForward,
    MdFavorite,
    MdCheck,
    MdSecurity,
    MdAccessTime,
    MdLocationOff,
    MdPlayArrow,
} from "react-icons/md";
import heroImageCard from "../../assets/checkinimg/safeCirclElderlyMan.png";
import "./CheckInLanding.css";

const features = [
    { icon: MdLocationOff, label: "No location tracking" },
    { icon: MdAccessTime, label: "Pause anytime" },
    { icon: MdSecurity, label: "End-to-end encrypted" },
];

const SafetyHero = () => {
    return (
        <section className="safety-hero-section" id="Home">
            <div className="hero-radial-bg"></div>
            <div className="glow-circle-bottom"></div>
            <Container>
                <Row className="align-items-center gy-5">
                    {/* Left Side */}
                    <Col lg={7}>
                        <div className="hero-left">
                            <div className="custome-badge">
                                <MdFavorite size={14} color="red" />
                                <span>A feeling of safety, simplified</span>
                            </div>

                            <h1 className="hero-main-title">
                                Confirm you're <span>safe.</span>
                            </h1>

                            <h2 className="hero-sub-title">We'll handle the rest.</h2>

                            <p className="hero-desc">
                                <span className="highlight-brand">safeCircl</span> is a personal
                                safety app that allows you to set timed check-ins before your
                                next trip, blind date, or late-night run. Confirm you’re safe
                                with a pre-scheduled text check- in. If you don’t
                                confirm,
                                <strong> we’ll notify your loved one.</strong>
                            </p>

                            <div className="hero-btn-group">
                                <Button className="btn-primary-custom">
                                    Sign up free
                                    <MdArrowForward size={18} className="ms-2" />
                                </Button>

                                <Button className="btn-outline-custom">
                                    <span className="play-icon">
                                        <MdPlayArrow size={16} />
                                    </span>
                                    See how it works
                                </Button>
                            </div>

                            <div className="hero-features">
                                {features.map((item, index) => {
                                    const Icon = item.icon;

                                    return (
                                        <div key={index} className="feature-box">
                                            <span className="check-round">
                                                <MdCheck size={14} />
                                            </span>
                                            <span>{item.label}</span>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </Col>

                    {/* Right Side */}
                    <Col lg={5}>
                        <div className="hero-image-area">
                            <div className="hero-image-card">
                                <img
                                    src={heroImageCard}
                                    alt="Safety Hero"
                                    className="safety-hero-image"
                                />
                            </div>

                            {/* Contact Card */}
                            {/*<div className="contact-card">*/}
                            {/*    <div>*/}
                            {/*        <h6>You're checked in</h6>*/}
                            {/*        <p>10:42 PM · All clear</p>*/}
                            {/*        <small>Next check-in in 42 min</small>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                            <p className="hero-caption">
                                "Because being proactive about your safety isn't about fear —
                                it's about freedom."
                            </p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export default SafetyHero;
